import { render, staticRenderFns } from "./productFilter.vue?vue&type=template&id=3d94cce3&scoped=true&"
import script from "./productFilter.vue?vue&type=script&lang=js&"
export * from "./productFilter.vue?vue&type=script&lang=js&"
import style0 from "./productFilter.vue?vue&type=style&index=0&id=3d94cce3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d94cce3",
  null
  
)

export default component.exports